var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "selector-wrap"
  }, [_c('Selector', {
    attrs: {
      "options": _vm.optionList,
      "disabled": _vm.disabled
    },
    on: {
      "dataChange": _vm.change
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }